import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getUserById } from "../api/api";
// import { environment } from "../environments/environments";
import environment from "../../environments/environments";
import "../CounsellorAllPages/CounsellorFinalSubmission.css";
import bgImage from "../../assets/images/brown-background.jpg";

const CounsellorFinalSubmission = () => {
  const navigate = useNavigate();
  const [userdata, setUserdata] = useState(null);
  const [refreshing, setRefreshing] = useState(false);

  const getUserdata = async () => {
    setRefreshing(true);
    try {
      const userData = localStorage.getItem("currentUser");
      if (userData) {
        const parsedUserData = JSON.parse(userData);
        const _id = parsedUserData?.id || parsedUserData?._id;
        const currentUser = await getUserById({ user_id: _id });

        console.log("User Info:", currentUser);
        setUserdata(currentUser);

        if (
          currentUser?.data?.approve_reject === "approved" &&
          currentUser?.data?.profile_completion_status === "Tab"
        ) {
          navigate("/CounsellorTab");
        }
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      navigate("/LoginCreateAccounts");
    } finally {
      setRefreshing(false);
    }
  };

  const onRefresh = useCallback(() => {
    getUserdata();
  }, []);

  useEffect(() => {
    getUserdata();
  }, []);

  return (
    <div className="final-submission-container sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}>
      <div className="containerall">
        <div className="final-submission">
          <div className="message-box">
            <p className="message-text">
              Thank you for submission! Please wait till your documents get verified
              by our system. You will be able to use the features once your
              documents are verified.
            </p>
            <p className="message-text">
              For other inquiries, please send an email to{" "}
              <span className="highlighted-text">info@connecttovow.com</span>.
            </p>
          </div>

          {/* Optional: Add refresh button for manual refresh */}
          <button
            className="refresh-button"
            onClick={onRefresh}
            disabled={refreshing}
          >
            {refreshing ? "Refreshing..." : "Refresh"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CounsellorFinalSubmission;
